import {HttpErrorResponse} from '@angular/common/http';
import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {NewsAnnouncement} from './news-announcement';
import {PersonLogin, RoleName} from '../person/person-login';
import {DocumentService} from '../services/document-service';
import {IecTaskService} from '../services/iec-task-service';
import {NewsAnnouncementService} from '../services/news-announcement-service';
import {PersonLoginService} from '../services/person-login-service';
import {IecTask} from '../tasks/iec-task';
import {StringUtils} from '../utils/string-utils';
import {DialogService} from "../services/dialog.service";
import {FileUtils} from "../utils/file-utils";
import { DatePipe } from '@angular/common';

@Component({
    selector: 'main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, RouterLinkActive, DatePipe]
})
export class MainComponent implements OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly iecTaskService = inject(IecTaskService);
  private readonly newsAnnouncementService = inject(NewsAnnouncementService);
  private readonly router = inject(Router);
  private readonly documentService = inject(DocumentService);
  private readonly dialogService = inject(DialogService);


  public personLogin!: PersonLogin;
  readonly iecTasks = signal<IecTask[]>(undefined!);
  readonly newsAnnouncements = signal<NewsAnnouncement[]>(undefined!);
  readonly errorMessage = signal<string>(undefined!);
  readonly marketingImage1 = signal<string | ArrayBuffer>(undefined!);
  readonly marketingImage2 = signal<string | ArrayBuffer>(undefined!);

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.personLogin = this.personLoginService.getCachedLogin()!;
      this.findMyWorkflowTasks();
      this.getActiveAnnouncements();
      this.loadMarketingImages();
    }
  }

  public findMyWorkflowTasks(): void {
    this.iecTaskService.findMyWorkflowTasks().subscribe(results => {
      this.iecTasks.set(results);
    }, error => this.handleError(error));
  }

  public getActiveAnnouncements(): void {
    this.newsAnnouncementService.getActiveAnnouncements().subscribe(results => {
      this.newsAnnouncements.set(results);
    }, error => this.handleError(error));
  }

  public showPartsDialog(): void {
    this.dialogService.showPartsDialog(null!).subscribe({
      next: (result) => {
        if (result) {
          this.router.navigate(['quotes', result.id.entityId, result.id.entityRevision]);
        }
      }, error: (error) => this.handleError(error)
    });
  }

  public hasRole(roleName: string): boolean {
    return this.personLoginService.hasRole(RoleName[roleName as keyof typeof RoleName]);
  }

  private handleError(error: HttpErrorResponse): void {
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  loadMarketingImages(): void {
    this.documentService.downloadMarketingDocument('Documentation/MarketingImages/MarketingImage1.png').subscribe(response => {
      if (response) {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          this.marketingImage1.set(reader.result!);
        }, false);
        reader.readAsDataURL(response);
      }
    });
    this.documentService.downloadMarketingDocument('Documentation/MarketingImages/MarketingImage2.png').subscribe(response => {
      if (response) {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          this.marketingImage2.set(reader.result!);
        }, false);
        reader.readAsDataURL(response);
      }
    });
  }

  isInternalUser(): boolean {
    return this.personLoginService.isInternal();
  }

}
